/**
 * Friendation component
 * @param component Instance of this _Friendation_ component
 */
const BasisPreHeader = (component: HTMLElement) => {
  const handleSitePickerOnMobile = () => {
    /**
     * Set the `width` of the {@link el} to the size of the selected value
     * @param el Any select element
     */
    const adjustSelectWidth = (el: HTMLSelectElement) => {
      const displayedText = el.options[el.selectedIndex].innerText;
      const dummy = document.createElement('div');
      dummy.innerText = displayedText;
      dummy.style.position = 'absolute';
      dummy.style.visibility = 'hidden';
      document.body.insertBefore(dummy, document.body.firstChild);
      const measuredWidth = dummy.clientWidth;
      document.body.removeChild(dummy);
      el.style.width =
        measuredWidth +
        parseInt(window.getComputedStyle(select).paddingRight) +
        'px';
    };

    const select: HTMLSelectElement = component.querySelector(
      '[name="mobileSiteSelect"]'
    );
    if (!select) return;

    const currentSiteUrl = select.value.trim();

    const onChange = (e: Event) => {
      e.preventDefault();

      /** This is a URL for another site */
      const targetSiteUrl = select.value.trim();

      adjustSelectWidth(select);

      if (currentSiteUrl !== targetSiteUrl) {
        /** Redirect to selected url */
        window.location.href = targetSiteUrl;
      }
    };

    select.addEventListener('change', onChange);
    adjustSelectWidth(select);
  };

  handleSitePickerOnMobile();
};

/** Selector for any instance of this _Friendation_ component */
const selector = '[is="basis-pre-header"]';

/** Function that handles a single instance of this _Friendation_ component */
const classFunction: (component: HTMLElement) => void = BasisPreHeader;

/**
 * Friendation component
 */
export const aBasisPreHeader = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((x) => {
    classFunction.call(this, x);
  });
};
